var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 0C19.3164 0 18.8046 0.195437 18.4141 0.585938L17 2L22 7L23.4141 5.58594C24.1951 4.80494 24.1951 3.53881 23.4141 2.75781L21.2422 0.585938C20.8517 0.195437 20.3399 0 19.8281 0ZM15 4L3.00001 16L4.50001 16.5L5.00001 19L7.50001 19.5L8.00001 21L20 9L15 4ZM1.15235 20.1523L0.037115 23.3086C0.012305 23.3693 -0.000304466 23.4344 5.58174e-06 23.5C5.58174e-06 23.6326 0.0526841 23.7598 0.146452 23.8536C0.24022 23.9473 0.367397 24 0.500006 24C0.562089 24.0003 0.623686 23.989 0.681646 23.9668L3.84766 22.8477L1.15235 20.1523Z",
    fill: "#F5F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.88902c5fe224fa769d695b10688f20c5.svg";
export { ForwardRef as ReactComponent };